import { render, staticRenderFns } from "./ybMedicine.vue?vue&type=template&id=ad22cf60&scoped=true"
import script from "./ybMedicine.vue?vue&type=script&lang=js"
export * from "./ybMedicine.vue?vue&type=script&lang=js"
import style0 from "./ybMedicine.vue?vue&type=style&index=0&id=ad22cf60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad22cf60",
  null
  
)

export default component.exports